import { Notifications, SplitLayout, UserContextMenuItem } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { useGetInboxToken } from 'notificationsApi/queries/inbox/inbox';
import { useGetSenderImageHook } from 'notificationsApi/queries/messages/messages';
import doka360Background from './assets/doka360-bg.webp';
import welcomeBackground from './assets/welcome-bg.jpg';

export const StartLayoutFrame = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { data: inboxToken, isLoading: isInboxTokenPending } = useGetInboxToken();
    const getSenderImage = useGetSenderImageHook();

    const getUserImageUrl = async (userId: string) => {
        const senderImageModel = await getSenderImage(userId);

        return senderImageModel?.data?.imageUri ?? undefined;
    };

    return (
        <div className="flex h-screen w-full flex-col">
            <SplitLayout
                backgroundImage={pathname.startsWith('/requests/doka360') ? doka360Background : welcomeBackground}
                childContainerClassName="h-full justify-center items-center xs:max-w-[464px]"
                className="m-auto"
                versionNumber={APP_VERSION}
            >
                <SplitLayout.HeaderItems>
                    <UserContextMenuItem
                        icon="domain"
                        title={t('myRegistrations')}
                        onClick={() => navigate('/requests')}
                    />
                    <Notifications
                        apiKey={inboxToken?.data?.publicApiKey ?? undefined}
                        getUserImageUrl={getUserImageUrl}
                        isLoading={isInboxTokenPending}
                        userId={inboxToken?.data?.userIdentifier}
                        userToken={inboxToken?.data?.token}
                    />
                </SplitLayout.HeaderItems>
                <SplitLayout.Content>
                    <Outlet />
                </SplitLayout.Content>
            </SplitLayout>
        </div>
    );
};
